// extracted by mini-css-extract-plugin
export default {"container":"Gallery_container__O0u-y","wrapper":"Gallery_wrapper__ZELfn","year":"Gallery_year__FMbMO","gallery":"Gallery_gallery__rdbyv"};